﻿import {AddressUnit} from "../types/AddressUnit";
import {unitDesignatorToString} from "./unitDesignatorToString";

export function unitToString(unit: AddressUnit): string {
	return unitDesignatorToString(unit.designator) + " " + unit.unit;
}
